import { render, staticRenderFns } from "./BaseCheckboxVertical.vue?vue&type=template&id=65a1b81e"
import script from "./BaseCheckboxVertical.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports